// Schema.org JSON-LD injection, kept separate from runtime OG/Twitter mutation.
import {
  SITE_URL,
  SITE_NAME,
  FAVICON_URL,
  SITE_OG_IMAGE,
  ARTICLE_IMAGE,
  routeSeoMap,
} from "./meta";

const JSON_LD_ID = "route-jsonld";

function organizationNode() {
  return {
    "@type": "Organization",
    name: SITE_NAME,
    url: SITE_URL,
    logo: {
      "@type": "ImageObject",
      url: FAVICON_URL,
    },
  };
}

function buildJsonLd(route: string, pathname: string): object | null {
  const url = `${SITE_URL}${pathname}`;
  const seo = routeSeoMap[route];

  if (route === "/") {
    return {
      "@context": "https://schema.org",
      "@graph": [
        {
          "@type": "WebSite",
          name: SITE_NAME,
          url: SITE_URL,
          description: seo?.description || "",
        },
        {
          ...organizationNode(),
          image: SITE_OG_IMAGE,
        },
      ],
    };
  }

  if (route === "/products") {
    return {
      "@context": "https://schema.org",
      "@type": "CollectionPage",
      name: seo?.title || "AllChinaBuy Spreadsheet Products",
      description: seo?.description || "",
      url,
      isPartOf: {
        "@type": "WebSite",
        name: SITE_NAME,
        url: SITE_URL,
      },
      publisher: organizationNode(),
    };
  }

  if (route === "/spreadsheet-guide") {
    return {
      "@context": "https://schema.org",
      "@type": "Article",
      headline: seo?.title || "AllChinaBuy Spreadsheet Guide",
      description: seo?.description || "",
      image: [ARTICLE_IMAGE],
      mainEntityOfPage: url,
      url,
      author: {
        "@type": "Organization",
        name: SITE_NAME,
        url: SITE_URL,
      },
      publisher: organizationNode(),
      datePublished: "2026-08-25",
      dateModified: "2026-08-25",
    };
  }

  return null;
}

export function applyJsonLd(route: string, pathname: string): void {
  removeJsonLd();
  const data = buildJsonLd(route, pathname);
  if (!data) return;

  const script = document.createElement("script");
  script.type = "application/ld+json";
  script.id = JSON_LD_ID;
  script.textContent = JSON.stringify(data);
  document.head.appendChild(script);
}

export function removeJsonLd(): void {
  const existing = document.getElementById(JSON_LD_ID);
  if (existing) existing.remove();
}